// Query performance of current path membership

import type { LearningPathItemType, TaskIcon } from "../../shared/types";

export interface IArgs {
    id: string;
}

export const query = `
query($id: String!) {
    pathMembership(id: $id) {
        id
        person {
            id
        }
        learningPath {
            id
            fixed
            numMembers
            membersPastCheckpoint
            membersPastGoal
            checkpoint
            goal
            leaderboards {
                id
                name
                mode
                specifiedTasks {
                    id
                }
                specifiedFeedbackTasks {
                    id
                }
                rankings {
                    pathMembershipId
                    firstName
                    lastName
                    rank
                    miles
                }
            }
            scoreboards {
                id
                name
                score
                specifiedTasks {
                    id
                }
                specifiedFeedbackTasks {
                    id
                }
            }
        }
        pathGroup {
            id
        }
        startDate
        endDate
        taskTime
        mySpeed
        ourSpeed
        miles
        pathGroupMemberMiles
        pathGroupMiles
        pathGroupMilesAvg
        allPathGroupMiles
        pathGroupSpeed
        memberMiles
        rank
        greenGoal
        yellowGoal
    }
}
`;

// Learning path query for task details
export interface ILearningPathArgs {
    id: string;
}

export const learningPathQuery = `
query($id: String!) {
    learningPath(id: $id) {
        id
        learningPathItems {
            id
            type
            tasks {
                id
                icon
                shortTitle
            }
            feedbackTask {
                id
                icon
                shortTitle
            }
        }
    }
}
`;

export interface IData {
    pathMembership: {
        id: string;
        person: {
            id: string;
        };
        learningPath: {
            id: string;
            fixed: boolean;
            numMembers: number;
            membersPastCheckpoint: number;
            membersPastGoal: number;
            checkpoint: number;
            goal: number;
            leaderboards: {
                id: string;
                name: string;
                mode: string;
                specifiedTasks: {
                    id: string;
                }[];
                specifiedFeedbackTasks: {
                    id: string;
                }[];
                rankings: {
                    pathMembershipId: number;
                    firstName: string;
                    lastName: string;
                    rank: number;
                    miles: number;
                }[];
            }[];
            scoreboards: {
                id: string;
                name: string;
                score: number;
                specifiedTasks: {
                    id: string;
                }[];
                specifiedFeedbackTasks: {
                    id: string;
                }[];
            }[];
        };
        pathGroup: {
            id: string;
        } | null;
        startDate: string;
        endDate: string;
        taskTime: string | null;
        mySpeed: number;
        ourSpeed: number;
        miles: number;
        pathGroupMemberMiles: number[];
        pathGroupMiles: number | null;
        pathGroupMilesAvg: number | null;
        allPathGroupMiles: number[] | null;
        pathGroupSpeed: number | null;
        memberMiles: number[] | null;
        rank: number | null;
        greenGoal: number;
        yellowGoal: number;
    };
}

// Learning path query interfaces
export interface ILearningPathItem {
    id: string;
    type: LearningPathItemType;
    tasks: {
        id: string;
        icon: TaskIcon;
        shortTitle: string;
    }[];
    feedbackTask: {
        id: string;
        icon: TaskIcon;
        shortTitle: string;
    } | null;
}

export interface ILearningPathData {
    learningPath: {
        id: string;
        learningPathItems: ILearningPathItem[];
    };
}
